/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { PlatformComponent } from '@karya/core';
import { PlatformComponentRenderer as PlatformComponentRendererConfig } from '../chakra/platform/Index';
import { getTypedComponent, type ComponentRendererProps } from '../chakra/shared/Types';
import { UnsupportedComponentRenderer } from './UnsupportedComponentRenderer';

/**
 * Stage 2 Renderer: Routes PLATFORM components by dtype
 */
export const PlatformComponentRenderer: React.FC<ComponentRendererProps> = ({ node, controller, isCurrent }) => {
  const component = getTypedComponent<PlatformComponent>(node);
  const ComponentRenderer = PlatformComponentRendererConfig[component.dtype];

  if (!ComponentRenderer) {
    return <UnsupportedComponentRenderer node={node} controller={controller} isCurrent={isCurrent} />;
  }

  return <ComponentRenderer node={node} controller={controller} isCurrent={isCurrent} />;
};
